<template>
  <div class="group">
    <hr
      class="border-t border-menu-border transition group-first:hidden"
      :class="[!context.isMobile ? `-mx-2 my-2` : `-mx-3 my-3`]"
    />

    <span
      class="my-1 block shrink-0 select-none px-3 text-[0.8125rem] leading-5 text-menu-muted-foreground transition group-first:mt-0"
    >
      <slot></slot>
    </span>
  </div>
</template>

<script lang="ts" setup>
import { inject } from "./context";

const context = inject();
</script>
